import React from 'react';
import { Link } from 'react-router';
import { Animated } from "react-animated-css";

class Card extends React.Component {
    render() {
        const { index, affiliate } = this.props;
        return (
            <Animated animationIn="fadeInRightBig" style={{ float: 'left' }} animationInDelay={50 * index}>
                <Link to={`/admin/affiliates/add/${affiliate.id}`}>
                    <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red" style={{ width: 250, height: 250 }}>
                        {affiliate.Logo && <div className="align-self-center d-flex flex-row justify-content-center" style={{ width: 200, height: 100 }}>
                            <img alt="" src={affiliate.Logo} className="align-self-center" style={{ maxWidth: 200, maxHeight: 100 }} /></div>}
                        {!affiliate.Logo && <i className="fas fa-shield-alt font-50 black align-self-center" />}
                        <span className="align-self-center font-18 text-center line1 margin-top-half anton toUpper black">{affiliate.Name}</span>
                    </figure>
                </Link>
            </Animated>
        )
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/private/affiliates/partials/card.js